import { ColorKey } from "./color-key";

export const cssColor = (name: ColorKey | (string & {})) => `var(--color-${name})`;
